// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mb-4[data-v-a7312590] {\n  margin-bottom: 1rem;\n}\n.mt-5[data-v-a7312590] {\n  margin-top: 1.5rem;\n}\n.retention-list[data-v-a7312590] {\n  list-style-type: disc;\n  margin-left: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
